"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignalRClientNotificationService = exports.ClientNotificationService = void 0;
var signalr_1 = require("@microsoft/signalr");
var ClientNotificationService = /** @class */ (function () {
    function ClientNotificationService(idToken, signalRBaseUrl) {
        this.channelsSubscribedTo = [];
        this.connection = null;
        try {
            var newConnection = new signalr_1.HubConnectionBuilder()
                .withUrl(signalRBaseUrl, {
                skipNegotiation: true,
                transport: signalr_1.HttpTransportType.WebSockets,
                accessTokenFactory: function () { return idToken; },
                // logger: console,
            })
                .withAutomaticReconnect()
                .build();
            this.connection = newConnection;
        }
        catch (error) {
            console.error(error);
        }
    }
    ClientNotificationService.prototype.startConnection = function () {
        return __awaiter(this, void 0, void 0, function () {
            var isConnected, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        isConnected = this.getIsConnected();
                        if (!!isConnected) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.connection.start()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, {
                                isConnected: true,
                                connection: this.connection,
                            }];
                    case 2: return [2 /*return*/, {
                            isConnected: false,
                            connection: this.connection,
                        }];
                    case 3:
                        error_1 = _a.sent();
                        console.error(error_1);
                        return [2 /*return*/, {
                                error: error_1,
                                isConnected: false,
                            }];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ClientNotificationService.prototype.stopConnection = function () {
        return __awaiter(this, void 0, void 0, function () {
            var isDisconnectedOrDisconnecting, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.connection) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        this.unSubscribeFromAllChannels();
                        isDisconnectedOrDisconnecting = [
                            signalr_1.HubConnectionState.Disconnected,
                            signalr_1.HubConnectionState.Disconnecting,
                        ].includes(this.connection.state);
                        if (isDisconnectedOrDisconnecting) {
                            return [2 /*return*/, {
                                    isDisconnected: false,
                                    error: 'Connection disconnected or disconnecting',
                                }];
                        }
                        return [4 /*yield*/, this.connection.stop()];
                    case 2:
                        _a.sent();
                        this.connection = null;
                        return [2 /*return*/, {
                                isDisconnected: true,
                                connection: this.connection,
                            }];
                    case 3:
                        error_2 = _a.sent();
                        return [2 /*return*/, {
                                isDisconnected: false,
                                error: error_2,
                            }];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ClientNotificationService.prototype.subscribeToChannel = function (channelKey, onMessage) {
        if (this.connection) {
            this.connection.on(channelKey, onMessage);
            this.channelsSubscribedTo = __spreadArray(__spreadArray([], this.channelsSubscribedTo, true), [channelKey], false);
            return true;
        }
        return false;
    };
    ClientNotificationService.prototype.unsubscribeFromChannel = function (channelKey) {
        if (this.connection && this.channelsSubscribedTo.includes(channelKey)) {
            this.connection.off(channelKey);
            this.channelsSubscribedTo = this.channelsSubscribedTo.filter(function (channel) { return channel !== channelKey; });
            return true;
        }
        return false;
    };
    ClientNotificationService.prototype.unSubscribeFromAllChannels = function () {
        var _this = this;
        if (this.connection) {
            this.channelsSubscribedTo.map(function (channelKey) { return _this.connection.off(channelKey); });
            this.channelsSubscribedTo = [];
            return true;
        }
        return false;
    };
    ClientNotificationService.prototype.getIsConnected = function () {
        var _a;
        return ((_a = this.connection) === null || _a === void 0 ? void 0 : _a.state) === signalr_1.HubConnectionState.Connected;
    };
    return ClientNotificationService;
}());
exports.ClientNotificationService = ClientNotificationService;
var SignalRClientNotificationService = /** @class */ (function () {
    function SignalRClientNotificationService(idToken, signalRBaseUrl) {
        var _this = this;
        this.connection = null;
        this.channelsSubscribedTo = [];
        try {
            var newConnection = new signalr_1.HubConnectionBuilder()
                .withUrl(signalRBaseUrl, {
                skipNegotiation: true,
                transport: signalr_1.HttpTransportType.WebSockets,
                accessTokenFactory: function () { return idToken; },
                // logger: console,
            })
                .withAutomaticReconnect()
                .build();
            this.connection = newConnection;
            this.connection.onclose(function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.start()];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); });
        }
        catch (error) {
            console.error(error);
        }
    }
    SignalRClientNotificationService.prototype.start = function () {
        var _this = this;
        return new Promise(function (resolve) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                // start the connection in a new context
                // to allow the HubConnection to be created and
                // initialized before the connection is started
                setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
                    var _a;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0: return [4 /*yield*/, ((_a = this.connection) === null || _a === void 0 ? void 0 : _a.start())];
                            case 1:
                                _b.sent();
                                resolve(true);
                                return [2 /*return*/];
                        }
                    });
                }); }, 0);
                return [2 /*return*/];
            });
        }); });
    };
    SignalRClientNotificationService.prototype.stop = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.connection) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.unsubscribeFromAllChannels()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.connection.stop()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    SignalRClientNotificationService.prototype.unsubscribeFromAllChannels = function () {
        var _this = this;
        return new Promise(function (resolve) {
            _this.channelsSubscribedTo.forEach(function (channel) {
                var _a;
                (_a = _this.connection) === null || _a === void 0 ? void 0 : _a.off(channel);
            });
            _this.channelsSubscribedTo = [];
            resolve(true);
        });
    };
    SignalRClientNotificationService.prototype.subscribeToChannel = function (channelKey, onMessage) {
        if (this.connection) {
            this.connection.on(channelKey, onMessage);
            this.channelsSubscribedTo = __spreadArray(__spreadArray([], this.channelsSubscribedTo, true), [channelKey], false);
            return true;
        }
        return false;
    };
    return SignalRClientNotificationService;
}());
exports.SignalRClientNotificationService = SignalRClientNotificationService;
//# sourceMappingURL=Notifications.js.map